//helper
import { getImageAsset } from "../../../../helpers/Images";

//components
import Icon from "../../icons/Icon";
import ExternalLoginIcon from "./ExternalLoginIcon";

//interfaces
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";
import { IExternalLoginUserImage } from "../../../../interfaces/image/image";



const ExternalLoginUserImage = ({profileImageUrl, providerIconUrl} :IExternalLoginUserImage) => {   

  return (
    <div className={`external-login-profile-image-wrapper`} aria-hidden="true">
        { profileImageUrl
            ?   <img src={getImageAsset(30, profileImageUrl) } className={`external-login-user-profile-image`} alt=""/>
            :   <Icon className={"default-no-user-icon"} iconName={IconLibrary.USER_NONE} sizeInPx="10" color={"var(--thriveLightSlate)"}/>
        }
        
        <ExternalLoginIcon iconUrl={providerIconUrl}/>
    </div>
  );
}
export default ExternalLoginUserImage